/*
 * @Author: your name
 * @Date: 2022-01-04 17:09:31
 * @LastEditTime: 2022-06-07 10:38:11
 * @LastEditors: zdx 3539255028@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\permission.js
 */
import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { message } from 'ant-design-vue'
import { getUrlValues } from '@/utils/qs'
import { ACCESS_TOKEN, INDEX_MAIN_PAGE_PATH, OAUTH2_LOGIN_PAGE_PATH, TENANT_ID } from '@/store/mutation-types'
import { generateIndexRouter, isOAuth2AppEnv } from '@/utils/util'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/user/login', '/user/register', '/user/register-result', '/user/alteration'] // no redirect whitelist
whiteList.push(OAUTH2_LOGIN_PAGE_PATH)

router.beforeEach((to, from, next) => {
  if (to.path === '/goAppExternal') {
    sessionStorage.setItem('appCode', to.query.app)
    Vue.ls.set(TENANT_ID, to.query.tenantId, 7 * 24 * 60 * 60 * 1000)
    store.commit('SET_TENANT', to.query.tenantId)
    next({ path: to.query.redirect })
    return;
  }
  if (to.redirectedFrom === '/') {
    sessionStorage.removeItem('appCode')
    Vue.ls.remove(TENANT_ID)
    store.commit('SET_TENANT', null)
  }
  NProgress.start() // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN)) {
    if (to.path === '/project' || to.path === '/dashboard/analysis' || to.path === '/online/cgreport/1471753054064025602') {
      sessionStorage.removeItem('appCode')
    }
    /* has token */
    if (to.path === '/user/login' || to.path === OAUTH2_LOGIN_PAGE_PATH) {
      next({ path: INDEX_MAIN_PAGE_PATH })
      NProgress.done()
    } else {
      if (store.getters.permissionList.length === 0) {
        const { app } = getUrlValues()
        if (app) {
          sessionStorage.setItem('appCode', app)
        }
        // if (!sessionStorage.getItem('appCode')) {
        //   sessionStorage.setItem('appCode', 'shanshe')
        //   next({ path: '/project' })
        //   return
        // }
        store.dispatch('GetPermissionList').then(res => {
          const menuData = res.result.menu
          const { apps, tenants } = res.result
          if (to.redirectedFrom === '/') {
            if (apps && apps.length > 0) {
              sessionStorage.setItem('appCode', apps[0].appCode)
              Vue.ls.set(TENANT_ID, 0, 7 * 24 * 60 * 60 * 1000)
              store.commit('SET_TENANT', null)
            } else if (tenants && tenants.length > 0 && tenants.apps && tenants.apps.length > 0) {
              sessionStorage.setItem('appCode', tenants[0].apps[0].appCode)
              Vue.ls.set(TENANT_ID, tenants[0].id, 7 * 24 * 60 * 60 * 1000)
              store.commit('SET_TENANT', tenants[0].id)
            }
          }
          if (menuData === null || menuData === '' || menuData === undefined) {
            return
          }
          if (!apps && apps.length === 0) {
            return
          }
          let constRoutes = []
          constRoutes = generateIndexRouter(menuData)

          // 添加主界面路由
          store.dispatch('UpdateAppRouter', { constRoutes }).then(() => {
            // 根据roles权限生成可访问的路由表
            // 动态添加可访问路由表
            router.addRoutes(store.getters.addRouters)
            const redirect = decodeURIComponent(apps[0].url)
            if (to.path === '/project' && apps.every(item => item.url !== '/project')) {
              if (redirect.startsWith("http")) {
                window.location.href = redirect
              } else {
                next({ path: redirect })
              }
              return
            }
            if (to.path === redirect) {
              // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
              next({ ...to, replace: true })
            } else {
              // 跳转到目的路由
              next({ path: to.path })
            }
          })
        })
          .catch((ex) => {
            console.error(ex)
            notification.error({
              message: '系统提示',
              description: '用户登录过程发生错误，请重试！点击可以返回登录页',
              onClick: () => {
                store.dispatch('Logout').then(() => {
                  next({ path: '/user/login', query: { redirect: to.fullPath } })
                })
              }
            })

          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，如果进入的页面是login页面并且当前是OAuth2app环境，就进入OAuth2登录页面
      if (to.path === '/user/login' && isOAuth2AppEnv()) {
        next({ path: OAUTH2_LOGIN_PAGE_PATH })
      } else {
        // 在免登录白名单，直接进入
        next()
      }
      NProgress.done()
    } else {
      // 如果当前是在OAuth2APP环境，就跳转到OAuth2登录页面
      let path = isOAuth2AppEnv() ? OAUTH2_LOGIN_PAGE_PATH : '/user/login'
      next({ path: path, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
